import _implicitStylesheets from "./installationLinks.css";
import _implicitScopedStylesheets from "./installationLinks.scoped.css?scoped=true";
import _appxEmptySpace from "appx/emptySpace";
import _c360Input from "c360/input";
import _c360TextArea from "c360/textArea";
import _c360ButtonIcon from "c360/buttonIcon";
import _c360Button from "c360/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="slds-size_2-of-3 slds-m-bottom_medium${0}"${2}><label class="section-description${0}"${2}>${"t2"}</label></div>`;
const $fragment2 = parseFragment`<div class="slds-grid slds-m-bottom_medium${0}"${2}><div class="slds-truncate install-link${0}"${"a1:title"}${2}>${"t2"}</div><div class="slds-truncate config${0}"${"a3:id"}${"a3:title"}${2}>${"t4"}</div><div class="action${0}"${2}></div></div>`;
const stc0 = {
  classMap: {
    "slds-form-element": true
  },
  key: 2
};
const stc1 = {
  "container": true
};
const stc2 = {
  "tabindex": "0"
};
const stc3 = {
  "container": true,
  "slds-grid": true
};
const stc4 = {
  classMap: {
    "install-link": true
  },
  key: 8
};
const stc5 = {
  "data-test-id": "link"
};
const stc6 = {
  classMap: {
    "config": true
  },
  key: 11
};
const stc7 = {
  "data-field": "description",
  "data-test-id": "description"
};
const stc8 = {
  classMap: {
    "action": true
  },
  key: 14
};
const stc9 = {
  "srw": true
};
const stc10 = [];
const stc11 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_align-end": true,
    "slds-m-top_x-small": true
  },
  key: 17
};
const stc12 = {
  "add-more": true
};
const stc13 = {
  "data-test-id": "addButton"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, c: api_custom_element, gid: api_scoped_id, k: api_key, h: api_element, i: api_iterator, f: api_flatten} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_static_fragment($fragment1, 1, [api_static_part(2, null, api_dynamic_text($cmp.label))]), api_element("div", stc0, [api_element("div", {
    classMap: stc1,
    attrs: stc2,
    key: 3,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.handleKeyboard))
    }
  }, api_flatten([$cmp.showEmptyState ? api_custom_element("appx-empty-space", _appxEmptySpace, {
    props: {
      "label": $cmp.requiredItemsLabel,
      "variant": "text",
      "required": $cmp.required,
      "requiredText": $cmp.requiredText
    },
    key: 4
  }) : null, !$cmp.showEmptyState ? api_flatten([api_static_fragment($fragment2, 6, [api_static_part(1, {
    attrs: {
      "title": $cmp.labels.installationLinksTableHeader
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.labels.installationLinksTableHeader)), api_static_part(3, {
    attrs: {
      "id": api_scoped_id("configAndData"),
      "title": $cmp.labels.configAndDataTableHeader
    }
  }, null), api_static_part(4, null, api_dynamic_text($cmp.labels.configAndDataTableHeader))]), api_iterator($cmp.installationLinks, function (option) {
    return api_element("div", {
      classMap: stc3,
      attrs: {
        "data-id": option.index
      },
      key: api_key(7, option.iteratorKey)
    }, [api_element("div", stc4, [api_element("div", {
      attrs: {
        "data-column": "0",
        "data-row": option.index
      },
      key: 9
    }, [api_custom_element("c360-input", _c360Input, {
      attrs: stc5,
      props: {
        "type": "uri",
        "value": option.link,
        "label": $cmp.labelsShared.value,
        "shouldHideLabel": true,
        "placeholder": $cmp.labelsShared.urlPlaceholder,
        "changeCallback": $cmp.handleChangeLink,
        "identifier": option.index,
        "typeData": "link",
        "requiredText": $cmp.labelsShared.requiredField,
        "invalidUrlError": $cmp.labelsShared.invalidSecureUrl,
        "required": true,
        "requireSecureUrl": true
      },
      key: 10
    })])]), api_element("div", stc6, [api_element("div", {
      attrs: {
        "data-column": "1",
        "data-row": option.index
      },
      key: 12
    }, [api_custom_element("c360-text-area", _c360TextArea, {
      attrs: stc7,
      props: {
        "rows": "1",
        "value": option.configData,
        "changeCallback": $cmp.handleChangeDescription,
        "ariaLabelledBy": api_scoped_id("configAndData"),
        "identifier": option.index,
        "maxLength": $cmp.maxLength,
        "requiredText": $cmp.labelsShared.requiredField,
        "forceShowError": $cmp.showInputErrors,
        "required": true
      },
      key: 13
    })])]), api_element("div", stc8, [api_element("div", {
      classMap: stc9,
      attrs: {
        "data-column": "2",
        "data-row": option.index
      },
      key: 15
    }, [api_custom_element("c360-button-icon", _c360ButtonIcon, {
      attrs: {
        "data-test-id": "removeButton",
        "data-index": option.index
      },
      props: {
        "iconButtonName": "utility:delete",
        "iconButtonVariant": "container",
        "iconDescription": $cmp.labelsShared.remove
      },
      key: 16,
      on: {
        "click": _m1 || ($ctx._m1 = api_bind($cmp.handleRemoveLink))
      }
    })])])]);
  })]) : stc10])), api_element("div", stc11, [api_custom_element("c360-button", _c360Button, {
    classMap: stc12,
    attrs: stc13,
    props: {
      "label": $cmp.labels.addLink,
      "iconPosition": "right",
      "variant": "brand-outline",
      "iconName": "utility:add"
    },
    key: 18,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handleAddLink))
    }
  })])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7q3gv8a4itf";
tmpl.legacyStylesheetToken = "appx-installationLinks_installationLinks";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
